import { GradientedScroller, connected, withErrorBoundary, NoResults} from 'shared'
import { TopLevelPage } from 'ui'
import SlideEventCard from 'ui/events/SlideEventCard'
import PeopleCard from 'ui/people/PeopleCard'
import { useEffect, useState, useRef } from 'react';
import cable from 'channels/cable'

let intervalId = null;

const GuestSecretCalenderView = ({ match, history }) => {
  const largeScreenId = match.params.id;
  const [slides, setSlides] = useState([]);
  const [sliderTime, setSliderTime] = useState("5000");
  const [refreshTime, setRefreshTime] = useState(2000);
  const [initialized, setInitialized] = useState(false);
  const [userCounter, setUserCounter] = useState();
  const [eventCounter, setEventCounter] = useState();
  const [touchScreenId, settouchScreenId] = useState()
  const [enabledTouch, setEnabledTouch] = useState(false)
  const [notFound, setNotFound] = useState(false)
  const [welcomeOverlayHidden, setWelcomeOverlayHidden] = useState(false)
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
  const overlayTimerRef = useRef(null)
  const subscriptionRef = useRef(null)

  const loadSlideData = () => {
    setWelcomeOverlayHidden(false)
    return Backend.get('/slides', { dsm_id: match.params.id, user_set_counter: userCounter, event_counter: eventCounter }).then((data) => {
      if (data && data.slides && data.slides.length > 0) {
        setSlides(data.slides);
        setSliderTime(data.slider_time);
        setRefreshTime(data.refresh_time ? data.refresh_time : 3600000);
        setUserCounter(data.user_set_counter ? data.user_set_counter : 0);
        setEventCounter(data.event_counter);
        settouchScreenId(data.tsm_id)
        setEnabledTouch(data.enabled_touch)
        setNotFound(false)
      } else {
        setSlides([])
        setNotFound(true)
      }
    }).catch((err) => {
      console.error("Failed to load slides:", err)
      setSlides([])
      setNotFound(true)
    });
  };

  const handleWelcomeClick = (slide) => {
    if (!enabledTouch && slide.type === "welcome") {
      setWelcomeOverlayHidden(true);
      if (overlayTimerRef.current)
        clearTimeout(overlayTimerRef.current);
      // Restore overlay 1 second before slide time ends
      const restoreTime = slide.timer * 1000 - 1000;
      if (restoreTime > 0)
        overlayTimerRef.current = setTimeout(() => { setWelcomeOverlayHidden(false); }, restoreTime);
    }
  };


  const handleRedirect = () => {
    if (enabledTouch)
      history.push({ pathname: "/touch-screen/" + touchScreenId, state: { from: history.location.pathname }})
  }

  useEffect(() => {
    const dsmId = match.params.id
    console.log("Connecting to WelcomeCenterChannel for DSM:", dsmId)

    const consumer = cable
    subscriptionRef.current = consumer.subscriptions.create(
      { channel: "WelcomeCenterChannel", dsm_id: dsmId },
      {
        connected: () => console.log("Cable connected"),
        disconnected: () => console.log("Cable disconnected"),
        received: (data) => {
          console.log("Received broadcast:", data)
          if (data.action == "show_now" && data.selected_tsm_id)
            history.push({ pathname: "/touch-screen/" + data.selected_tsm_id, search: "?dsm_id=" + dsmId, state: { from: history.location.pathname }})
        }
      }
    )

    return () => {
      console.log("Unsubscribing from channel")
      subscriptionRef.current?.unsubscribe()
    }
  }, [])

  useEffect(() => {
    console.log("Inside useEffect");
    if (!initialized) {
      loadSlideData().then(() => setInitialized(true));
    }

    if (intervalId) clearInterval(intervalId);

    return () => {
      clearInterval(intervalId)
      if (overlayTimerRef.current)
        clearTimeout(overlayTimerRef.current)
    }
  }, [initialized, refreshTime, userCounter, eventCounter]);

  useEffect(() => {
    if (enabledTouch) {
      document.body.addEventListener("click", handleRedirect)
      document.body.addEventListener("touchstart", handleRedirect)
      return () => {
        document.body.removeEventListener("click", handleRedirect)
        document.body.removeEventListener("touchstart", handleRedirect)
      }
    }
  }, [touchScreenId, enabledTouch]);

  return (
    <TopLevelPage className="Calendar" fullWidth={true} modelId={largeScreenId} base="/community-calendar">
      { notFound ?
          <div className="text-center mt-10">
            <h2>No Large Screen Found</h2>
            <p>Please check the ID or contact support.</p>
          </div>
        :
        <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            {slides?.length > 0 ? slides.map((slide, index) => (
              <div key={index} className={index === 0 ? "carousel-item active" : "carousel-item"} data-interval={slide.timer * 1000}>
                {slide.type === 'image' ? (
                  <div className="iframe-modal">
                    <img src={slide.data} style={{ width: '100%', height: '500px' }} />
                  </div>
                ) : slide.type === 'web' ? (
                  <div className="iframe-modal">
                    <iframe src={slide.file_path} width="100%" height="500px" scrolling="no" style={{ border: 'none', overflow: 'hidden' }} />
                  </div>
                ) : slide.type === 'checkin' ? (
                  <div className='container-fluid p-5 mx-5'>
                    <div className="row">
                      <div className="col">
                        <h1 className="section-heading-lowercase my-3 text-left">{slide.data.title}</h1>
                      </div>
                    </div>
                    { slide.users.length == 0 ? <NoResults>We’re sorry, this section contains no checked in members.</NoResults> :
                      <GradientedScroller containerClassName="feed-columns row">
                        {slide.users.map((model) => (
                          <section className="feed-column col-sm-6 col-lg-4 col-xl-3" key={model.uid}>
                            <div className="feed-column-body">
                              <PeopleCard user={model} key={model.id} base='/large-screen' />
                            </div>
                          </section>
                        ))}
                      </GradientedScroller>
                    }
                  </div>
                ) : slide.type === 'welcome' ? (
                  <div
                    style={{
                      position: 'relative',
                      height: '100vh',
                      cursor: enabledTouch ? 'pointer' : 'default'
                    }}
                    onClick={(e) => handleWelcomeClick(slide, e)}
                    onTouchStart={(e) => handleWelcomeClick(slide, e)}
                  >
                    {
                      enabledTouch ? (
                        slide.data.bg_file_path.endsWith('.mp4') || slide.data.bg_file_path.endsWith('.webm') ?
                          <video className="w-100 h-100 " src={slide.data.bg_file_path} autoPlay={true} loop={true} muted={true} controls={false} style={{ width: '100%', height: '100vh', objectFit: 'cover' }} />
                        :
                          <img className="w-100" src={slide.data.bg_file_path} style={{ width: '100%', height: '100vh' }} />
                      ) :
                        <div className="iframe-modal">
                          <iframe
                            src={slide.iframe_url}
                            width="100%"
                            scrolling="no"
                            style={{
                              border: 'none',
                              overflow: 'hidden',
                              height: '100vh',
                              pointerEvents: welcomeOverlayHidden ? 'auto' : 'none'
                            }}
                          />
                        </div>
                    }

                    { !welcomeOverlayHidden && (
                      <>
                        { slide.data.logo_file_path && <img src={slide.data.logo_file_path} className="welcome-logo" /> }
                        <div className="welcome-text">
                          <h1 className="welcome-header" style={{ color: (enabledTouch || slide.data.iframe == "" ? '#FFFFFF' : '#000000') }}>{slide.data.header}</h1>
                          <h3 className="welcome-subheader" style={{ color: (enabledTouch || slide.data.iframe == "" ? '#FFFFFF' : '#000000') }}>{slide.data.subheader}</h3>
                        </div>
                      </>
                    )}
                  </div>
                ) : slide.type === 'event' ? (
                  <div className='container-fluid p-5 mx-5'>
                    {slide.data.title ? (
                      <div className="row justify-content-center text-left">
                        <div className="col-md-8">
                          <h1 className="section-heading-lowercase my-3">{slide.data.title}</h1>
                        </div>
                      </div>
                    ) : (
                      <div className="centered-title"></div>
                    )}
                    {slide.data.events.length === 0 ? (
                      <NoResults>We’re sorry, this section contains no events.</NoResults>
                    ) : (
                      <GradientedScroller containerClassName="feed-columns row">
                        {slide.data.events.map((model) => (
                          <section className="feed-column col-sm-6 col-lg-4 col-xl-3" key={model.uid}>
                            <div className="feed-column-body">
                              <SlideEventCard event={model} key={model.id} base='/large-screen' />
                            </div>
                          </section>
                        ))}
                      </GradientedScroller>
                    )}
                  </div>
                ) : (
                  <div key="noSlides">No slides available</div>
                )}
              </div>
            )) : (
              <div key="noSlides">No slides available</div>
            )}
          </div>
        </div>
      }
    </TopLevelPage>
  );
};

export default withErrorBoundary(connected(GuestSecretCalenderView));
